module.exports = __webpack_public_path__ + "media/images/emblems/Taegerwilen-fc9893173be495a46a8f3b804729c5af.GIF";